
import Vue from "vue";
import { mapState } from "vuex";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { IRootState } from "@/store/types";
import { LOYALTY, emptyCampaign } from "@/store/loyalty";
import { cloneDeep } from "@/helpers/object";

export default Vue.extend({
  props: {
    id: {
      // Comes through as a number from the router
      // And a string if you hit the URL directly
      type: [Number, String],
      required: false
    }
  },
  data() {
    return {
      loyaltyCampaignListRoute: LOYALTY_ROUTE_NAMES.CAMPAIGNS
    };
  },
  computed: {
    ...mapState({
      isLoading: (state: IRootState) => state.loyalty.isLoading
    })
  },
  beforeMount() {
    // Ref data needs to be loaded before the campaign data
    this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CHANNEL_REFERENCE_DATA)
    );

    this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_SEGMENT_REFERENCE_DATA)
    );
  },
  async mounted() {
    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), true);

    // reset campaign
    this.$store.commit(
      LOYALTY.NS(LOYALTY.MUTATIONS.SET_CAMPAIGN),
      cloneDeep(emptyCampaign)
    );

    if (this.id) {
      await this.$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CAMPAIGN),
        this.id
      );
    }

    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), false);
  }
});
